<template>
    <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8.5L4 8.5" stroke="#868E96" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/>
        <path d="M12 12.5L4 12.5" stroke="#868E96" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/>
        <path d="M12 4.5L4 4.5" stroke="#868E96" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"/>
    </svg>
</template>

<script>
export default {
    name: 'HamburgerSvg',
};
</script>
